import React, {useEffect, useState, useRef, useContext } from "react"
import { Typography,Container,Grid,Paper } from "@material-ui/core"

export const FallbackUI = () => {
  
    return (
        <Container  maxWidth="lg">
      
            <Paper style={{marginTop: '35vh'}}>
                <Grid
                container
                direction="column"      
                alignItems="center"
                spacing={5}
                >
                    <Grid  item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h2" color="textSecondary" align="center">
                        Ουπς... Κάτι πήγε στραβά. 
                        </Typography>
                    </Grid>
                    <Grid  item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6" color="textSecondary" align="center">
                            Λυπούμαστε, αλλά παρουσιάστηκε ένα μη αναμενόμενο σφάλμα. Η ομάδα υποστήριξης μας ενημερώθηκε για το πρόβλημα και εργάζεται για να το επιλύσει. Ζητούμε συγνώμη για τυχόν αναστάτωση και εκτιμούμε την υπομονή σας ενώ εργαζόμαστε για την επίλυση του προβλήματος.
                        </Typography>
                    </Grid>
                    <Grid  item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h6" color="textSecondary" align="center">
                            Εδώ είναι μερικά πράγματα που μπορείτε να δοκιμάσετε για να αντιμετωπίσετε το πρόβλημα:
                            <li>Ξαναφορτώστε την εφαρμογή. </li>
                            <li>Ξαναφορτώστε τον φυλλομετρητή (browser).</li>
                        </Typography>
                    </Grid>
                    <Grid  item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="body1" color="textSecondary" align="center">
                           Σε περίτωση που συνεχίσετε να αντιμετωπίζετε προβήματα, μπορείτε προσωρινά να χρησιμοποιήσετε το <a href="https://www.e-prescription.gr/" target="_blank">Σύστημα ηλ. συνταγογράφησης της ΗΔΙΚΑ </a>
                        </Typography>
                    </Grid>
                    
                </Grid>
            </Paper>

      </Container>
    )
  }